import React from 'react';
import { FadeIn } from './FadeIn';
import { Plane, Shield } from 'lucide-react';
export function UniqueMethod() {
  return <section className="py-24 px-4 bg-brand-dark relative overflow-hidden" data-id="element-170">
      {/* Background subtle grid */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#333_1px,transparent_1px),linear-gradient(to_bottom,#333_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)] opacity-20" data-id="element-171" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-172">
        <FadeIn data-id="element-173">
          <div className="text-center mb-16" data-id="element-174">
            <span className="text-brand-orange font-bold tracking-widest uppercase text-sm mb-4 block" data-id="element-175">
              El Mecanismo Único
            </span>
            <h2 className="text-5xl md:text-6xl font-display font-bold text-white uppercase" data-id="element-176">
              El Método <span className="text-brand-orange" data-id="element-177">"Caja Negra"</span>
            </h2>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-178">
          <FadeIn delay={0.2} data-id="element-179">
            <div className="p-8 border-2 border-brand-orange bg-brand-gray rounded-xl shadow-[0_0_40px_rgba(255,102,0,0.1)] relative" data-id="element-180">
              <div className="absolute -top-6 -left-6 bg-brand-dark p-4 rounded-full border-2 border-brand-orange" data-id="element-181">
                <div className="w-8 h-8 text-brand-orange" data-id="element-182" />
              </div>
              <p className="text-xl text-gray-300 leading-relaxed font-medium" data-id="element-183">
                Inspirado en la aviación, este sistema filtra lo innecesario
                para dejar solo lo{' '}
                <span className="text-white font-bold" data-id="element-184">indestructible</span>.
              </p>
              <div className="mt-8 space-y-6" data-id="element-185">
                <div className="flex gap-4" data-id="element-186">
                  <Plane className="w-6 h-6 text-brand-orange flex-shrink-0 mt-1" data-id="element-187" />
                  <p className="text-gray-400" data-id="element-188">
                    No te enseñamos a hacer fuego con piedras; te damos la
                    estructura de hierro para que tu identidad, tu salud y tu
                    alimentación estén blindadas en una sola mochila que
                    cualquier miembro de la familia pueda cargar.
                  </p>
                </div>
                <div className="flex gap-4" data-id="element-189">
                  <Shield className="w-6 h-6 text-brand-orange flex-shrink-0 mt-1" data-id="element-190" />
                  <p className="text-gray-400" data-id="element-191">
                    Es un riel de decisiones pre-tomadas para que tú no tengas
                    que pensar bajo presión.
                  </p>
                </div>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.4} direction="left" data-id="element-192">
            <div className="relative" data-id="element-193">
              {/* Decorative elements */}
              <div className="absolute inset-0 bg-brand-orange/10 blur-2xl rounded-full" data-id="element-194" />
              <img src="https://cdn.magicpatterns.com/uploads/eNHZrdy6SqzupgGKrv7vfL/PROTOCOLO_72_HORAS_portada.png" alt="Método Caja Negra" className="relative z-10 w-full max-w-md mx-auto drop-shadow-2xl opacity-90" data-id="element-195" />
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}